import moment from "moment";

export const getDateData = (dateStamp: any) => {
  const d: any = new Date(dateStamp);
  return {
    day: parseInt(d.getDate()),
    month: parseInt(d.getMonth() + 1),
    year: parseInt(d.getFullYear()),
  };
};

export const compareDates = (date: any, filterDate: any) => {
  return (
    moment(date).isSameOrAfter(filterDate.from) &&
    moment(date).isSameOrBefore(filterDate.to)
  );
};
